import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-contact-center',
  templateUrl: './modal-contact-center.component.html',
  styleUrls: ['./modal-contact-center.component.scss'],
})
export class ModalContactCenterComponent implements OnInit {
  emailSupport: string;
  emailSac: string;
  site: string;

  constructor(public modalController: ModalController) { }


  ngOnInit() {
    this.emailSupport = environment.wlThemeParameterization.wlTheme.company.emailSupport;
    this.emailSac = environment.wlThemeParameterization.wlTheme.company.emailSac;
    this.site = environment.wlThemeParameterization.wlTheme.company.site;
  }

  openEmail(email:string){
    window.location.href = `mailto:${email}`;
  }

  public openWhatsapp() {
    const url = environment.wlThemeParameterization.wlTheme.help.apiWhatsapp;
    window.open(url, '_blank');
  }

  close(){
    this.modalController.dismiss();
  }

  

}
